export default "__VITE_ASSET__C7mJW53U__"